import styles from './styles.scss';

type Variant = 'normal' | 'darker' | 'lighter';

const tgStylesNormal = {
  '-1': styles.itemTgIUNormal,
  '0': styles.itemTg0Normal,
  '1': styles.itemTg1Normal,
  '2': styles.itemTg2Normal,
  '3': styles.itemTg3Normal,
};

const tgStylesDarker = {
  '-1': styles.itemTgIUDarker,
  '0': styles.itemTg0Darker,
  '1': styles.itemTg1Darker,
  '2': styles.itemTg2Darker,
  '3': styles.itemTg3Darker,
};

const tgStylesLighter = {
  '-1': styles.itemTgIULighter,
  '0': styles.itemTg0Lighter,
  '1': styles.itemTg1Lighter,
  '2': styles.itemTg2Lighter,
  '3': styles.itemTg3Lighter,
};

const getTGBackgroundColor = (tg: number, variant: Variant = 'normal'): string => {
  switch (variant) {
    case 'darker':
      return tgStylesDarker[tg];
    case 'lighter':
      return tgStylesLighter[tg];
    default:
      return tgStylesNormal[tg];
  }
};

export default getTGBackgroundColor;
